/* ============================================================================
   lightbox-zoom.js — mărirea pozelor din galerie (8.1-z)
   ----------------------------------------------------------------------------
   RO: Cerut de Alex: în galerie (chat, DM, sesiuni — orice `openLightbox`) poza
       trebuie să se poată mări, ca în orice aplicație de poze. Mărirea nativă a
       paginii e oprită în aplicație (`user-scalable=no` în index.html), deci pe
       Android nu se putea mări deloc, iar pe iOS se mărea TOATĂ pagina.
       Aici, doar poza:
         • telefon: prindere cu două degete (în jurul degetelor), dublă atingere
           (2,5× acolo unde ai atins / înapoi), deplasare cu un deget când e mărită;
         • desktop: rotița (în jurul cursorului), dublu clic, tragere cu mausul,
           tastele + / − / 0;
         • mărită: glisarea spre poza următoare și închiderea prin atingerea
           fundalului sunt oprite; o atingere pe fundal o micșorează la loc;
         • poza nu iese din ecran (marginile se opresc la margine), între 1× și 4×;
         • la schimbarea pozei (săgeți / glisare) se revine la 1×.
       Doar `transform` (fără recalcularea paginii), pointer events (maus, deget,
       creion într-un singur cod), `prefers-reduced-motion` respectat.
       Legătura cu galeria (app-core.js): `TO_ZOOM.attach(ov, img)` la deschidere,
       `TO_ZOOM.reset()` la schimbarea pozei, `TO_ZOOM.detach()` la închidere.
       v9 8.5-B2: tot aici, deschiderea instantă cu miniatura + descărcarea
       originalelor (`shown`, `fitTo`, `unfit`, `preload`, `sharpen`).
   EN: image-only pinch / wheel / double-tap zoom with pan for the lightbox,
       plus thumbnail-first opening and original prefetch (8.5-B2). */
(function () {
    'use strict';
    if (window.TO_ZOOM) return;

    var MAX = 4, DBL = 2.5, TAP_MS = 300, TAP_PX = 25;
    var z = null;

    function logErr(where, e) { try { if (typeof window.logError === 'function') window.logError(where, e); } catch (x) { /* noop */ } }
    function reduced() { try { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) { return false; } }

    /* Dimensiunea și centrul pozei la 1× (fără transformare). */
    function measure() {
        if (!z) return;
        var prev = z.img.style.transform;
        z.img.style.transform = 'none';
        var r = z.img.getBoundingClientRect();
        z.img.style.transform = prev;
        z.bw = r.width; z.bh = r.height;
        z.cx = r.left + r.width / 2; z.cy = r.top + r.height / 2;
    }
    function clamp() {
        var vw = window.innerWidth, vh = window.innerHeight;
        var mx = Math.max(0, (z.bw * z.s - vw) / 2), my = Math.max(0, (z.bh * z.s - vh) / 2);
        /* centrul pozei poate pleca de la centrul ecranului cât e nevoie ca marginea să ajungă la margine */
        var ox = z.cx - vw / 2, oy = z.cy - vh / 2;
        z.x = Math.min(mx - ox, Math.max(-mx - ox, z.x));
        z.y = Math.min(my - oy, Math.max(-my - oy, z.y));
        if (z.s <= 1.001) { z.s = 1; z.x = 0; z.y = 0; }
    }
    function apply(animate) {
        if (!z) return;
        z.img.style.transition = (animate && !reduced()) ? 'transform .2s ease' : 'none';
        z.img.style.transform = (z.s === 1 && !z.x && !z.y) ? '' : 'translate(' + z.x + 'px,' + z.y + 'px) scale(' + z.s + ')';
        var on = z.s > 1.001;
        z.ov.classList.toggle('lb-zoomed', on);
        z.img.style.cursor = on ? 'grab' : 'zoom-in';
    }
    /* Mărire la `s2` păstrând punctul de ecran (fx, fy) sub deget / cursor. */
    function zoomAt(s2, fx, fy, animate) {
        s2 = Math.max(1, Math.min(MAX, s2));
        var qx = (fx - z.cx - z.x) / z.s, qy = (fy - z.cy - z.y) / z.s;
        z.s = s2;
        z.x = fx - z.cx - s2 * qx; z.y = fy - z.cy - s2 * qy;
        clamp(); apply(animate);
    }
    function reset(animate) {
        if (!z) return;
        z.s = 1; z.x = 0; z.y = 0; z.pts = {}; z.pinch = null; z.pan = null;
        apply(animate);
    }
    function isZoomed() { return !!z && z.s > 1.001; }
    function onButton(e) { return !!(e.target && e.target.closest && e.target.closest('button')); }

    function onWheel(e) {
        if (!z || onButton(e)) return;
        e.preventDefault();
        measure();
        /* Firefox raportează rotița în RÂNDURI (deltaMode 1), nu în pixeli ⇒ ~16 px/rând. */
        var dy = e.deltaY * (e.deltaMode === 1 ? 16 : (e.deltaMode === 2 ? 400 : 1));
        zoomAt(z.s * Math.exp(-dy * 0.0015), e.clientX, e.clientY, false);
    }
    function onDbl(e) {
        if (!z || onButton(e)) return;
        e.preventDefault();
        measure();
        if (isZoomed()) reset(true); else zoomAt(DBL, e.clientX, e.clientY, true);
    }
    function onDown(e) {
        if (!z || onButton(e)) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        z.pts[e.pointerId] = { x: e.clientX, y: e.clientY };
        var ids = Object.keys(z.pts);
        z.moved = false;
        if (ids.length === 2) {
            var a = z.pts[ids[0]], b = z.pts[ids[1]];
            measure();
            z.pinch = { d: Math.hypot(a.x - b.x, a.y - b.y) || 1, s: z.s, mx: (a.x + b.x) / 2, my: (a.y + b.y) / 2 };
            z.pan = null;
        } else if (ids.length === 1 && isZoomed()) {
            z.pan = { x: e.clientX, y: e.clientY, x0: z.x, y0: z.y };
            z.img.style.cursor = 'grabbing';
        }
        if (ids.length >= 2 || isZoomed()) { try { z.ov.setPointerCapture(e.pointerId); } catch (x) { /* noop */ } }
    }
    function onMove(e) {
        if (!z || !z.pts[e.pointerId]) return;
        var p = z.pts[e.pointerId];
        if (Math.abs(e.clientX - p.x) > 4 || Math.abs(e.clientY - p.y) > 4) z.moved = true;
        p.x = e.clientX; p.y = e.clientY;
        var ids = Object.keys(z.pts);
        if (z.pinch && ids.length >= 2) {
            var a = z.pts[ids[0]], b = z.pts[ids[1]];
            var d = Math.hypot(a.x - b.x, a.y - b.y) || 1, mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
            /* deplasarea mijlocului dintre degete mută și poza */
            z.x += mx - z.pinch.mx; z.y += my - z.pinch.my;
            z.pinch.mx = mx; z.pinch.my = my;
            zoomAt(z.pinch.s * d / z.pinch.d, mx, my, false);
        } else if (z.pan) {
            z.x = z.pan.x0 + (e.clientX - z.pan.x); z.y = z.pan.y0 + (e.clientY - z.pan.y);
            clamp(); apply(false);
        }
    }
    function onUp(e) {
        if (!z || !z.pts[e.pointerId]) return;
        delete z.pts[e.pointerId];
        z.upAt = Date.now();
        var left = Object.keys(z.pts).length;
        if (left < 2) z.pinch = null;
        if (left === 0) { z.pan = null; apply(false); }
        else if (left === 1 && isZoomed()) {
            var id = Object.keys(z.pts)[0];
            z.pan = { x: z.pts[id].x, y: z.pts[id].y, x0: z.x, y0: z.y };
        }
        /* dublă atingere pe ecranul tactil (dblclick nu e de încredere cu touch-action: none) */
        if (e.pointerType !== 'mouse' && !z.moved && left === 0 && !onButton(e)) {
            var now = Date.now(), lt = z.lastTap;
            if (lt && now - lt.t < TAP_MS && Math.abs(e.clientX - lt.x) < TAP_PX && Math.abs(e.clientY - lt.y) < TAP_PX) {
                z.lastTap = null; z.ignoreClick = now;
                measure();
                if (isZoomed()) reset(true); else zoomAt(DBL, e.clientX, e.clientY, true);
            } else z.lastTap = { t: now, x: e.clientX, y: e.clientY };
        }
    }
    /* Mărită (sau în plin gest cu două degete) ⇒ glisarea galeriei nu primește nimic. */
    function guardTouch(e) {
        if (!z) return;
        if (isZoomed() || z.pinch || (e.touches && e.touches.length > 1)) e.stopImmediatePropagation();
    }
    /* Mărită: atingerea fundalului micșorează, nu închide; după o deplasare, clicul
       de la final nu contează; dubla atingere nu închide nici ea. */
    function guardClick(e) {
        if (!z || onButton(e)) return;
        /* doar clicul care vine IMEDIAT după o deplasare e al ei, nu unul de mai târziu */
        var justMoved = z.moved && Date.now() - (z.upAt || 0) < 400;
        var swallow = isZoomed() || justMoved || (z.ignoreClick && Date.now() - z.ignoreClick < 400);
        if (!swallow) return;
        e.stopImmediatePropagation(); e.preventDefault();
        if (isZoomed() && !justMoved && e.target === z.ov) reset(true);
        z.moved = false;
    }
    function onKey(e) {
        if (!z) return;
        var k = e.key;
        if (k === '+' || k === '=' || k === '-' || k === '0') {
            e.preventDefault(); measure();
            var cx = window.innerWidth / 2, cy = window.innerHeight / 2;
            if (k === '0') reset(true);
            else zoomAt(z.s * (k === '-' ? 1 / 1.5 : 1.5), cx, cy, true);
        }
    }
    function onResize() {
        if (!z) return;
        var f = z.img.getAttribute('data-lb-fit');   /* miniatura încă afișată ⇒ își reface mărimea (8.5-B2) */
        if (f) { var p = f.split('x'); fitTo(z.img, +p[0], +p[1]); }
        measure(); clamp(); apply(false);
    }

    /* ── v9 8.5-B2: galeria se deschide INSTANT cu miniatura deja descărcată ──────
       RO: Din 8.5-B colajul descarcă doar miniatura, deci originalul pleacă abia la
           apăsare (înainte venea odată cu colajul ⇒ galeria părea instantă; rezoluția
           e aceeași). Acum: arătăm imediat miniatura, mărită la cât ar ocupa poza,
           descărcăm originalul și îl punem în locul ei abia când e gata (fără clipire).
           Poza veche, fără miniatură, se deschide ca înainte.
       EN: show the already-loaded thumbnail at once, swap in the original when decoded. */
    var THUMB_RE = /[.]thumb[.]jpg([?#]|$)/;
    function shown(el) {
        try {
            if (!el || !el.getAttribute || el.hasAttribute('data-sp')) return null;   /* încă nesemnată */
            var u = el.currentSrc || el.src || '';
            if (!THUMB_RE.test(u) || !el.complete || !el.naturalWidth) return null;
            return { url: u, w: el.naturalWidth, h: el.naturalHeight };
        } catch (e) { return null; }
    }
    /* Miniatura (480 px) primește mărimea pe care o va avea originalul (încadrat în
       96vw × 92vh, ca în app-core), ca la înlocuire poza să nu sară. */
    function fitTo(img, w, h) {
        if (!img || !w || !h) return;
        var k = Math.min(window.innerWidth * 0.96 / w, window.innerHeight * 0.92 / h);
        img.style.width = Math.round(w * k) + 'px';
        img.style.height = Math.round(h * k) + 'px';
        img.setAttribute('data-lb-fit', w + 'x' + h);
        if (z && z.img === img) measure();
    }
    function unfit(img) {
        if (!img) return;
        img.style.width = ''; img.style.height = ''; img.style.opacity = '';
        img.removeAttribute('data-lb-fit');
    }
    /* Descărcarea unui original într-o imagine separată, ținută în `cache[key]` (altfel
       browserul o poate abandona); `decode()` ⇒ înlocuirea nu mai așteaptă decodarea. */
    function preload(cache, key, url) {
        var c = cache[key];
        if (c && c.url === url) return c.done;
        var im = new Image();
        c = cache[key] = { url: url, img: im, ok: false, done: null };
        c.done = new Promise(function (ok, ko) {
            im.onload = function () {
                var gata = false, fin = function () { if (gata) return; gata = true; c.ok = true; ok(); };
                /* ⚠ `decode()` așteaptă un cadru desenat: cât pagina nu desenează (ascunsă,
                   aplicația în fundal) nu se termină — găsit la verificarea în browser, unde
                   originalul venise, dar miniatura rămânea. După 300 ms punem poza oricum. */
                setTimeout(fin, 300);
                try { if (im.decode) { im.decode().then(fin, fin); return; } } catch (e) { /* noop */ }
                fin();
            };
            im.onerror = function () { if (cache[key] === c) delete cache[key]; ko(new Error('preload')); };
        });
        im.src = url;
        return c.done;
    }
    /* Pune originalul în galerie când a venit — doar dacă e tot poza de pe ecran
       (`isCurrent`). Dacă nu vine (rețea), rămâne miniatura: mai bine decât o poză stricată. */
    function sharpen(img, url, cache, key, isCurrent) {
        return preload(cache, key, url).then(function () {
            if (!isCurrent() || !img.isConnected) return false;
            if (img.src !== url) img.src = url;
            unfit(img);
            return true;
        }, function () {
            if (!isCurrent() || !img.isConnected) return false;
            img.style.opacity = '';
            if (!THUMB_RE.test(img.src)) img.src = url;   /* fără miniatură: ca înainte */
            return false;
        });
    }

    function detach() {
        if (!z) return;
        var o = z.ov;
        try {
            o.removeEventListener('wheel', onWheel);
            o.removeEventListener('dblclick', onDbl);
            o.removeEventListener('pointerdown', onDown);
            o.removeEventListener('pointermove', onMove);
            o.removeEventListener('pointerup', onUp);
            o.removeEventListener('pointercancel', onUp);
            o.removeEventListener('touchstart', guardTouch, true);
            o.removeEventListener('touchmove', guardTouch, true);
            o.removeEventListener('touchend', guardTouch, true);
            o.removeEventListener('click', guardClick, true);
            document.removeEventListener('keydown', onKey);
            window.removeEventListener('resize', onResize);
        } catch (e) { logErr('TO_ZOOM.detach', e); }
        z = null;
    }
    function attach(ov, img) {
        try {
            detach();
            if (!ov || !img) return;
            z = { ov: ov, img: img, s: 1, x: 0, y: 0, pts: {}, pinch: null, pan: null, moved: false, upAt: 0, lastTap: null, ignoreClick: 0, bw: 0, bh: 0, cx: 0, cy: 0 };
            /* Gesturile le tratăm noi ⇒ browserul nu mai mărește pagina și nici nu derulează. */
            ov.style.touchAction = 'none';
            img.style.touchAction = 'none';
            img.style.cursor = 'zoom-in';
            img.style.willChange = 'transform';
            img.draggable = false;
            ov.addEventListener('wheel', onWheel, { passive: false });
            ov.addEventListener('dblclick', onDbl);
            ov.addEventListener('pointerdown', onDown);
            ov.addEventListener('pointermove', onMove);
            ov.addEventListener('pointerup', onUp);
            ov.addEventListener('pointercancel', onUp);
            ov.addEventListener('touchstart', guardTouch, { capture: true, passive: true });
            ov.addEventListener('touchmove', guardTouch, { capture: true, passive: true });
            ov.addEventListener('touchend', guardTouch, { capture: true, passive: true });
            ov.addEventListener('click', guardClick, true);
            document.addEventListener('keydown', onKey);
            window.addEventListener('resize', onResize);
            img.addEventListener('load', function () {
                if (!z || z.img !== img) return;
                /* 8.5-B2: originalul care înlocuiește miniatura e ACEEAȘI poză, la aceeași
                   mărime ⇒ mărirea deja începută rămâne (la poza următoare, app-core resetează). */
                if (isZoomed()) { measure(); clamp(); apply(false); return; }
                reset(false); measure();
            });
            measure();
        } catch (e) { logErr('TO_ZOOM.attach', e); }
    }

    window.TO_ZOOM = {
        attach: attach,
        detach: detach,
        reset: function () { reset(false); },
        isZoomed: isZoomed,
        /* 8.5-B2 (app-core: openLightbox / _lbGoto / _lbPrefetch) */
        shown: shown,
        fitTo: fitTo,
        unfit: unfit,
        preload: preload,
        sharpen: sharpen,
        /* doar pentru teste: starea curentă */
        _state: function () { return z ? { s: z.s, x: z.x, y: z.y } : null; }
    };
})();
